/*!
 * Copyright © 2019. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { EHarshDrivingEventClassification } from '../../../core/models';

@Component({
  selector: 'fm-harsh-driving-event-balloon-badge',
  templateUrl: './harsh-driving-event-balloon-badge.component.html',
  styleUrls: ['./harsh-driving-event-balloon-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HarshDrivingEventBalloonBadgeComponent {
  @Input()
  classification: EHarshDrivingEventClassification;

  EHarshDrivingEventClassification = EHarshDrivingEventClassification;
}
